import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { CognitoService } from '../services/cognito.service';
import { RoleChangeService } from '../services/role-change.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private cognitoService: CognitoService,
    private router: Router,
    private roleChangeService: RoleChangeService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      const isAuthenticated = await this.cognitoService.isAuthenticated();
      if (isAuthenticated) {
        const currentUrl = state.url;

        // Use RoleChangeService to handle role changes and route validation
        const canAccess = await this.roleChangeService.handleRoleTransition(currentUrl);

        if (!canAccess) {
          // RoleChangeService has already handled the redirect and notification
          return false;
        }

        return true;
      } else {
        await this.router.navigate(['auth/login']);
        return false;
      }
    } catch (error) {
      console.error('Auth guard error:', error);
      await this.router.navigate(['auth/login']);
      return false;
    }
  }
}
